export class Collana {
  codice: string;
  copertinaCatalogo: string;
  codiceCEC: string;
  descrizione: string;
  formato: string;
  formatoCatCartaceo: string;
  frmAltezza: string;
  frmLarghezza: string;
  frmSpessore: string;
  numID: string;
  ordCatalogo: number;
  ordinamento: string;
  showcat: boolean;
  showweb: boolean;
  oldcat: boolean;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Collana.ts